import { Types } from '@kvass/media-render'
import { i18n } from '@/i18n'
import { setup as MediaRenderSetup } from '@kvass/media-render'

MediaRenderSetup({
  consentBlockMessage: i18n.t('cookieVideoBlockMessage'),
  consentButtonLabel: i18n.t('editConsents'),
})

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    valueComp() {
      return this.value.map(item => {
        return {
          ...item,
          type: this.getType(this.$path('image.type', item)),
          Component: this.getComponent(this.$path('image.type', item)),
        }
      })
    },
  },

  methods: {
    getType(type) {
      switch (type) {
        case 'youtube':
          return 'youtube'
        case 'vimeo':
          return 'vimeo'
        default:
          return 'image'
      }
    },

    getComponent(type) {
      switch (type) {
        case 'youtube':
          return Types.Youtube
        case 'vimeo':
          return Types.Vimeo
        default:
          return Types.Image
      }
    },
  },
}
